// extracted by mini-css-extract-plugin
export var active = "_ca-7";
export var container = "_ca-0";
export var evenWidth = "_ca-4";
export var large = "_ca-5";
export var outlet = "_ca-8";
export var slide = "_ca-2";
export var small = "_ca-6";
export var tab = "_ca-3";
export var tabs = "_ca-1";